// AlternateBarcodesModal — every OTHER barcode the hero product scans
// as, beyond the one the dark action bar is already showing.
//
// Opened by tapping the action bar's barcode area when the product has
// additional barcodes (signalled by the yellow "+" badge). Display-only:
// scanning stays live underneath — the global keydown listener lives on
// the parent screen — so the picker can scan straight from the popup;
// the X (or tapping the backdrop) closes it.
import { X } from "lucide-react";
import { useTranslation } from "../../i18n";
import { groupBarcode } from "./barcodeFormat";
import "./AlternateBarcodesModal.css";

interface Props {
    /** The additional barcodes only — the caller excludes the one on
     *  the action bar before opening. */
    barcodes: string[];
    onClose: () => void;
}

const AlternateBarcodesModal = ({ barcodes, onClose }: Props) => {
    const { t } = useTranslation();
    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-card alt-barcodes-modal" onClick={e => e.stopPropagation()}>
                <div className="modal-card-header">
                    <h2>{t("picking_alt_barcodes_title")}</h2>
                    <button className="modal-close" onClick={onClose} aria-label={t("close")}>
                        <X size={18} />
                    </button>
                </div>
                <div className="modal-card-body">
                    <div className="alt-barcodes-hint">{t("picking_alt_barcodes_hint")}</div>
                    <ul className="alt-barcodes-list">
                        {barcodes.map(bc => (
                            <li key={bc} className="alt-barcodes-item">{groupBarcode(bc)}</li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default AlternateBarcodesModal;
